import script from "./AudioUploadPrompt.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioUploadPrompt.vue?vue&type=script&setup=true&lang=ts"

import "./AudioUploadPrompt.vue?vue&type=style&index=0&id=97493072&lang=scss"

const __exports__ = script;

export default __exports__